import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Fornitore } from '../model/fornitore';
import { FornitoreServiceService } from '../service/fornitore-service.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-comodity',
  templateUrl: './comodity.component.html',
  styleUrls: ['./comodity.component.scss']
})
export class ComodityComponent implements OnInit {

  id: number;
  private sub: any;

  lstfornitori: Array<Fornitore>;


  constructor(private route: ActivatedRoute, private router: Router, private servicefornitore: FornitoreServiceService) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id']; // (+) converts string 'id' to a number
      // this.lstfornitori = this.servicefornitore.getfornitoribyComodity(this.id);
      this.lstfornitori = null;
      this.servicefornitore.getfornitoribyComodity(this.id).subscribe(data => {
        this.lstfornitori = data
        if (this.lstfornitori.length == 1) {
          this.router.navigateByUrl('/ListaOfferte/' + this.id + '/' + this.lstfornitori[0].Id_fornitore, { skipLocationChange: true });

        }
      }
      );


      // se unico fornitore va direttamente alla pagian del fornitore
      // if (this.lstfornitori.length == 1) {
      //   this.router.navigateByUrl('/ListaOfferte/' + this.id + '/' + this.lstfornitori[0].Id_fornitore, { skipLocationChange: true });

      // }

      // In a real app: dispatch action to load the details here.
      // window.scrollTo(0,0);
    });
    //  service= new FornitoreServiceService();
    //  this.lstfornitori= service.getfornitoribyComodity(this.id);


  }


}



// WEBPACK FOOTER //
// ./src/app/comodity/comodity.component.ts